module.exports = __webpack_public_path__ + "img/logout.f0f91ce6.svg";